import { wrapCreateBrowserRouterV6 } from '@sentry/react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import ProductDetailUrlRedirect from 'src/features/product/product-detail/ui/ProductDetailUrlRedirect';
import * as Reporting from 'src/services/reporting';
import { DEBUG_MODE_ENABLED, ENVIRONMENT } from 'src/settings';
import { ROUTE_PATHS } from 'src/shared/config/routes';

import AccountPage from 'src/pages/account-page/AccountPage';
import BuildAnythingPage from 'src/pages/build-anything-page/BuildAnythingPage';
import BuildAnythingPrintPage from 'src/pages/build-anything-page/BuildAnythingPrintPage';
import ExpiredPage from 'src/pages/expired-page/ExpiredPage';
import HomePage from 'src/pages/home-page/HomePage';
import LoginPage from 'src/pages/login-page/LoginPage';
import NotFoundPage from 'src/pages/not-found-page/NotFoundPage';
import OnboardingDiscoveryPage from 'src/pages/onboarding-discovery-page/OnboardingDiscoveryPage';
import OrganizationPage from 'src/pages/organization-page/OrganizationPage';
import ProductDetailPage from 'src/pages/product-detail-page/ProductDetailPage';
import ProductsPage from 'src/pages/products-page/ProductsPage';
import RegisterPage from 'src/pages/register-page/RegisterPage';
import RegisterThankYouPage from 'src/pages/register-thank-you-page/RegisterThankYouPage';
import SupplierApplicationPage from 'src/pages/supplier-application-page/SupplierApplicationPage';

import ErrorBoundaryLayout from '../layouts/ErrorBoundaryLayout';
import PrivateLayout from '../layouts/PrivateLayout';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

Reporting.init({
  environment: ENVIRONMENT,
  debugModeEnabled: DEBUG_MODE_ENABLED as boolean
});

const sentryCreateBrowserRouter =
  wrapCreateBrowserRouterV6(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
  {
    element: <ErrorBoundaryLayout />,
    children: [
      {
        element: <PublicRoute />,
        children: [
          {
            path: ROUTE_PATHS.LOGIN,
            element: <LoginPage />
          },
          {
            path: ROUTE_PATHS.EXPIRED,
            element: <ExpiredPage />
          },
          {
            path: ROUTE_PATHS.REGISTER,
            element: <RegisterPage />
          },
          {
            path: ROUTE_PATHS.REGISTER_THANK_YOU,
            element: <RegisterThankYouPage />
          }
        ]
      },
      {
        element: <PrivateRoute />,
        children: [
          {
            element: <PrivateLayout />,
            children: [
              { path: ROUTE_PATHS.PRODUCTS, element: <ProductsPage /> },
              {
                path: ROUTE_PATHS.PRODUCT_DETAIL,
                element: <ProductDetailPage />
              },
              {
                path: ROUTE_PATHS.PRODUCT_DETAIL_TAB,
                element: <ProductDetailUrlRedirect />
              },
              { path: ROUTE_PATHS.ORGANIZATION, element: <OrganizationPage /> },
              { path: ROUTE_PATHS.ACCOUNT, element: <AccountPage /> }
            ]
          },
          {
            element: <Navigate to={ROUTE_PATHS.BUILD_ANYTHING} replace />,
            path: ROUTE_PATHS.NEW_RFQ
          },
          {
            element: <BuildAnythingPage />,
            path: ROUTE_PATHS.BUILD_ANYTHING
          },
          {
            element: <BuildAnythingPrintPage />,
            path: ROUTE_PATHS.BUILD_ANYTHING_PRINT
          },
          {
            element: <OnboardingDiscoveryPage />,
            path: ROUTE_PATHS.ONBOARDING_DISCOVERY
          }
        ]
      },
      {
        path: '/',
        element: <HomePage />
      },
      {
        path: ROUTE_PATHS.SUPPLIER_APPLICATION,
        element: <SupplierApplicationPage />
      },
      {
        path: '*',
        element: <NotFoundPage />
      }
    ]
  }
]);

export default router;
